import { render, staticRenderFns } from "./WizardReviewStep.vue?vue&type=template&id=11caa882&scoped=true&"
import script from "./WizardReviewStep.vue?vue&type=script&lang=js&"
export * from "./WizardReviewStep.vue?vue&type=script&lang=js&"
import style0 from "./WizardReviewStep.vue?vue&type=style&index=0&id=11caa882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11caa882",
  null
  
)

export default component.exports